import type { AuditTrailItem } from '@skewb-works/contracts';
import { formatTimestamp } from './auditTrailFormatters';

function escapeCsvField(value: string): string {
  if (value.includes(',') || value.includes('"') || value.includes('\n')) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

function valueToCSvString(value: unknown): string {
  if (value === null || value === undefined) return '';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
}

const CSV_HEADER =
  'Timestamp,User,Event Type,Entity Type,Entity ID,Field,Previous Value,New Value,Reason';

export function formatAuditTrailCsv(items: AuditTrailItem[]): string {
  const rows = items.map((item) => {
    const fields = [
      formatTimestamp(item.created_at),
      item.username,
      item.event_type,
      item.entity_type,
      String(item.entity_id),
      item.field_name ?? '',
      valueToCSvString(item.previous_value),
      valueToCSvString(item.new_value),
      item.reason ?? '',
    ];
    return fields.map(escapeCsvField).join(',');
  });

  return [CSV_HEADER, ...rows].join('\n');
}

export function formatAuditTrailJson(items: AuditTrailItem[]): string {
  return JSON.stringify(items, null, 2);
}

export function downloadFile(content: string, filename: string, mimeType: string): void {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
